import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../../../components/ui/dialog';
import { InferDependenciesSection } from './infer-dependencies-section';

/**
 * "Suy ra phụ thuộc còn thiếu" trong một hộp thoại — APM-UX-ai6.
 *
 * Trước đây đứng cố định ở chân trang Gantt (một khối luôn chiếm chỗ dù
 * không ai đang cần nó). Nay là một mục trong popup "Sửa nhanh" — cạnh
 * "Sửa hàng loạt bằng lời", vì cả hai đều là AI đề xuất trên diện rộng của
 * dự án, không gắn với một task đang mở. `InferDependenciesSection` không
 * đổi gì bên trong; chỉ đổi chỗ nó đứng.
 */
export function InferDependenciesDialog({
  projectId,
  onClose,
}: {
  readonly projectId: string;
  readonly onClose: () => void;
}): ReactNode {
  const { t } = useTranslation();

  return (
    <Dialog label={t('inferDeps.title')} onClose={onClose}>
      {/*
        Không thêm `<h2>` riêng: `InferDependenciesSection` đã tự có tiêu đề
        (icon + chữ) ở đầu khối, và nó **luôn mở** ở đây (`defaultOpen`) —
        thêm một tiêu đề nữa phía trên chỉ lặp lại đúng dòng chữ đó.
      */}
      <InferDependenciesSection projectId={projectId} defaultOpen />
    </Dialog>
  );
}
